import EventTags from './EventTags';

const EventCardTags = ({ event, count, noPadding }) => (
  <div className={`mt-2 w-full text-right ${noPadding ? '' : 'p-2'}`}>
    <EventTags event={event} count={count || 3} />
  </div>
);

export default EventCardTags;
